const calculateFromDate = (index: number) => {
  let subtract = 0;
  index === 0
    ? (subtract = 365)
    : index === 1
    ? (subtract = 30)
    : index === 2
    ? (subtract = 7)
    : (subtract = 0);

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - subtract);
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const formattedDate = year + '-' + month + '-' + day;
  return formattedDate;
};

export default calculateFromDate;
